<wk-icon-phone-sprite-pds3 />
<icon-pds3 name="wk-icon-phone" />
@if (cardModalService.currentCard()?.contactInformation?.phone) {
    <span class="wk-cm__header__icon-text">{{ cardModalService.currentCard().contactInformation?.phone }}</span>
}

<tooltip-pds3
    elementId="phone_icon_tooltip"
    position="bottom"
    mode="indicator"
    [openDelay]="600"
    [closeDelay]="50"
    targetSelector=".wk-cm__header__icon-phone"
>
    {{ "CardModal.HomePhone" | translate }}
</tooltip-pds3>
